<script setup>
    import { useUserStore } from '@/stores/user'
    const userStore = useUserStore();
    userStore.$reset();

    import { useIncentivesStore } from '@/stores/incentives'
    const incentivesStore = useIncentivesStore();
    incentivesStore.$reset();

    import { useBusinessPartnersStore } from '@/stores/businessPartners'
    const businessPartnersStore = useBusinessPartnersStore();
    businessPartnersStore.$reset();

    import { useAuthStore } from '@/stores/auth'
    const authStore = useAuthStore();

    // Static button styling: use classes directly -> btn--auth (grün), btn--white (weiß), btn--danger (rot)
    // To switch style just change the class list on the button in the template.
</script>

<template>
    <div class="login-wrapper max-width">
        <div class="login-header">
            <div class="header-content">
                <img class="logo" src="@/assets/imgs/logos/sellwerk/Sellwerk_logo_Mittelstand_rgb-white-sternprinzip.svg">
                <p  data-aos="fade-up"
                    data-aos-easing="ease-out-sine"
                    data-aos-delay="250">Willkommen bei deinem</p>
                <h1 data-aos="fade-in"
                    data-aos-easing="ease-out-sine"
                    data-aos-delay="250"><br><b>Sales Manager <br> Assistant!<sup>SMA 26.3.3</sup></b></h1>
                <p  data-aos="fade-down"
                    data-aos-easing="ease-out-sine"
                    data-aos-delay="250">Logge Dich ein, um deine Kampagnen effizient zu verwalten und alle relevanten Informationen auf einen Blick zu haben.</p>
                <!-- <button class="btn"><a class="buttonlink" href="#form">Zum Login</a></button> -->
                <div class="buttons">
                    <!-- Haupt-Login Button: Style wählen durch Austausch der Variante
                         Optionen: btn--auth (grün) | btn--white (weiß) | btn--danger (rot) -->
                    <button @click="authStore.login()" class="btn btn--white btn--hero btn--pill btn--lg login-cta">
                        <img alt="Einloggen" src="@/assets/imgs/icons/arrow-right-to-bracket-solid.svg" />
                        <span>Einloggen</span>
                    </button>
                    <!-- Beispiel alternative Varianten (auskommentieren & aktivieren bei Bedarf)
                    <button @click="authStore.login()" class="btn btn--white btn--hero btn--pill btn--lg login-cta">
                        <img alt="Einloggen" src="@/assets/imgs/icons/arrow-right-to-bracket-solid.svg" />
                        <span>Einloggen</span>
                    </button>
                    <button @click="authStore.login()" class="btn btn--danger btn--hero btn--pill btn--lg login-cta">
                        <img alt="Einloggen" src="@/assets/imgs/icons/arrow-right-to-bracket-solid.svg" />
                        <span>Einloggen</span>
                    </button>
                    -->
                </div>
            </div>
            <!-- <div class="clip-path-wrapper">
                <div class="clip-path"></div>
                <div class="clip-path"></div>
                <div class="clip-path"></div>
            </div> -->
            <picture>
                <source media="(min-width: 1024px)" srcset="@/assets/imgs/login/login-header-bg-01-desktop.svg">
                <source srcset="@/assets/imgs/login/login-header-bg-01.svg">
                <img class="header_bg_image" src="@/assets/imgs/login/login-header-bg-01.svg" alt="">
            </picture>
            <picture>
                <source media="(min-width: 1024px)" srcset="@/assets/imgs/login/login-header-bg-02-desktop.svg">
                <source srcset="@/assets/imgs/login/login-header-bg-02.svg">
                <img class="header_bg_image" src="@/assets/imgs/login/login-header-bg-02.svg" alt="">
            </picture>
            <!-- <div class='box'>
                <div class='wave -one'> </div>
                <div class='wave -two'></div>
            </div> -->
        </div>
    </div>
</template>

<style scoped>
.variant-switch { display:flex; gap:.35rem; margin-top:.9rem; }
.variant-switch .btn { font-size:.55rem; padding:.35rem .55rem; }
</style>